module.exports = __webpack_public_path__ + "img/baojialogo.0dc1938e.jpg";